import { Navigate, useLocation, useParams } from "react-router-dom";
import { APP_MANAGED_ROUTES } from "common/app-managed-routes";

// The About me page moved to `/my-health-dashboard` (EMBLEM-10173). Keep the
// sub-path (`/insights/...`, `/hra-report`) and query (`?view=achievements`)
// so old deeplinks land on the same view.
export const LegacyAboutMeRouteRedirect = () => {
  const { "*": subPath } = useParams();
  const { search, hash } = useLocation();
  return (
    <Navigate
      to={{
        pathname: subPath
          ? `${APP_MANAGED_ROUTES.MY_HEALTH_DASHBOARD}/${subPath}`
          : APP_MANAGED_ROUTES.MY_HEALTH_DASHBOARD,
        search,
        hash,
      }}
      replace
    />
  );
};
